import Store from "@/store/index.js";
import axios from 'axios'
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';


const domain = Store.state.domain;
export default {

    async ObtenerEstadoMovimientos(nrreporte, svindice) {
        var formData = new FormData();
        formData.append("nrreporte", nrreporte);
        formData.append("svindice", svindice);
        let response = await axios.post(`${domain.domainNameForApi}SeguimientosReporte/EstadoMovimientos`, formData);
        return response.data;
    },

    async ObtenerDatosMovimientos(nrreporte, svindice, ceclave) {
        var formData = new FormData();
        formData.append("nrreporte", nrreporte);
        formData.append("svindice", svindice);
        formData.append("idmov", ceclave);

        let response = await axios.post(`${domain.domainNameForApi}SeguimientosReporte/ObtenerDatosMovimiento`, formData);

        return response.data[0];
    },

    async RegistrarMovimiento(nrreporte, svindice, ceclave, exresp, exobs, exfecha) {

        let aseg = sessionStorage.getItem("asegName");

        var formData = new FormData();
        formData.append("nrreporte", nrreporte);
        formData.append("svindice", svindice);
        formData.append("ceclave", ceclave);
        formData.append("exresp", exresp);
        formData.append("exobs", exobs);
        formData.append("exfecha", exfecha);
        formData.append("asegurado", aseg);

        let response = await axios.post(`${domain.domainNameForApi}SeguimientosReporte/RegistrarMovimiento`, formData);

        return response.data[0];
    },

    async RegistrarMovimientoRecepFisc(nrreporte, svindice, ceclave, exresp, exobs, exfecha, gdid) {

        var formData = new FormData();
        formData.append("nrreporte", nrreporte);
        formData.append("svindice", svindice);
        formData.append("ceclave", ceclave);
        formData.append("exresp", exresp);
        formData.append("exobs", exobs);
        formData.append("exfecha", exfecha);
        formData.append("gdid", gdid);

        let response = await axios.post(`${domain.domainNameForApi}SeguimientosReporte/RegistrarMovimientoRecepFisc`, formData);

        return response.data[0];
    },

    async ObtenerEstadoRecpDocsFisc(nrreporte, svindice) {
        var formData = new FormData();
        formData.append("nrreporte", nrreporte);
        formData.append("svindice", svindice);
        let response = await axios.post(`${domain.domainNameForApi}SeguimientosReporte/ObtenerEstadoRecepcionDocFis`, formData);

        return response.data;
    },
    tramiteGuardarMovimientoDemerito(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.nrreporte);
        formData.append("svindice", vm.svindice);
        formData.append("ceclave", vm.ceclave);
        formData.append("exresp", "S");
        formData.append("exobs", vm.datos.comentarios);
        formData.append("exfecha", vm.datos.fecha);
        formData.append("doctos", JSON.stringify(vm.documentos));
        return vm.axios.post(`${vm.domain.domainNameForApi}SeguimientosReporte/TramiteGuardarMovimientoDemerito`, formData).then(response => response.data)

    },

    obtenerDocumentosTramite(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.nrreporte);
        formData.append("svindice", vm.svindice);
        vm.axios.post(`${vm.domain.domainNameForApi}SeguimientosReporte/ObtenerDocumentosTramite`, formData).then(response => {

            vm.documentos = response.data;

        })
    },
    tramiteGuardarMovimiento(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.nrreporte);
        formData.append("svindice", vm.svindice);
        formData.append("ceclave", vm.ceclave);
        formData.append("exresp", vm.checks);
        formData.append("exobs", vm.datos.comentarios);
        formData.append("exfecha", vm.fecha);
        return vm.axios.post(`${vm.domain.domainNameForApi}SeguimientosReporte/TramiteGuardarMovimiento`, formData).then(response => response.data)

    },

    obtenerdatosReporte(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.nrreporte);
        formData.append("svindice", vm.svindice);
        formData.append("ceclave", vm.ceclave);
        vm.axios.post(`${vm.domain.domainNameForApi}SeguimientosReporte/ObtenerdatosReporte`, formData).then(response => {

            if (vm.ceclave == 644) {

                vm.titleMov = response.data[0].ceconcepto;
            }
            else {
                vm.minDateFh = response.data[0].svfhreporte;
                vm.titleMov = response.data[0].ceconcepto;
            }

        })

    },
    validarTramites(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.reporte);
        formData.append("svindice", vm.indice);
        formData.append("aiclave", vm.aiclave);
        vm.axios.post(`${vm.domain.domainNameForApi}SeguimientosReporte/ValidarTramites`, formData).then(response => {

            vm.valconclusion = response.data[0].Concluido;
            vm.valdocsausa = response.data[0].valdoc;
            vm.valSeguimiento = response.data[0].valseguimiento;
        })
    },

    obtenerdemeritos(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.nrreporte);
        formData.append("svindice", vm.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}SeguimientosReporte/Obtenerdemeritos`, formData).then(response => response.data)
    },
    obtenerDocumentosAusa(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.nrreporte);
        formData.append("svindice", vm.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}SeguimientosReporte/ObtenerDocumentosAusa`, formData).then(response => response.data)


    },

    guardarValidacionDocumentosAusa(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.nrreporte);
        formData.append("svindice", vm.svindice);
        formData.append("doctos", JSON.stringify(vm.documentos));
        return vm.axios.post(`${vm.domain.domainNameForApi}SeguimientosReporte/GuardarValidacionDocumentosAusa`, formData).then(response => response.data)

    },
    validarEdicion(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.nrreporte);
        formData.append("svindice", vm.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}SeguimientosReporte/validarEdicion`, formData).then(response => response.data)

    },

    Estatus(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}SeguimientosReporte/ObtenerEstatus`).then(response => response.data)
    },
    async AsignarEstatus(datos, ceclave, estatus) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("estatus", estatus);
        formData.append("ceclave", ceclave);
        return axios.post(`${domain.domainNameForApi}SeguimientosReporte/AgregarEstatus`, formData).then(response => response.data)
    }
};